import { useEffect, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ProviderNoteForm from "@components/forms/ProviderNoteForm";
import { ProviderInvoiceApi, ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import { ProviderInvoiceFormDataKeys } from "@/generated/ProviderInvoiceFormDataKeys";
import { ProviderInvoiceRelatedAttributes } from "@/formTypes/ProviderInvoiceDataType";

const ProviderNoteAddEdit = () => {
  const params = useParams()
  const { id: providerInvoiceNoteId, providerInvoiceId } = params;
  const [providerInvoice, setProviderInvoice] = useState<ProviderInvoiceDataType>({})

  useEffect(() => {
    if (providerInvoiceId) {
      const run = async (providerInvoiceId: string) => {
        const invoices = await ProviderInvoiceApi.get(providerInvoiceId, {
          selectionSet: [
            ...ProviderInvoiceFormDataKeys.filter(k => !ProviderInvoiceRelatedAttributes.includes(k)),
            "currency.*",
            "provider.*"
          ]
        });
        setProviderInvoice(invoices);
      }
      run(providerInvoiceId);
    }
  }, [providerInvoiceId]);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!providerInvoiceNoteId ? 'Agregar' : 'Editar'} Nota de Factura`}
      backUrl={`/user/provider-invoices/notes/${providerInvoiceId}`}
      primaryActions={
        [
          {
            actionTitle: "Guardar",
            formId: "providerInvoiceNoteForm",
            type: "submit",
            color: "success"
          }
        ]}
    >
      {providerInvoice?.id && (
        <ProviderNoteForm
          formId="providerInvoiceNoteForm"
          id={providerInvoiceNoteId}
          providerInvoice={providerInvoice}
          saveRedirectUrl={`/user/provider-invoices/notes/${providerInvoiceId}`}
        ></ProviderNoteForm>
      )}

    </PageContainer >
  );
}

export default ProviderNoteAddEdit;
